(function ($, undefined) {
    var sm = window.sm = window.sm || {};

    if (typeof sm.portal === "undefined") {
        $.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        $.extend(sm.portal, { vm: {} });
    }

    /************************************************/
    /* Full Application View Model                  */
    /************************************************/
    function ApplicationViewModel() {

        // Self-Identification
        var self = this;
        var ukFeatureEnabled = sm.portal.utility.isUKFeatureEnabled();
        var euFeatureEnabled = sm.portal.utility.isEUFeatureEnabled();
        var apasFeatureEnabled = sm.portal.utility.isAPASFeatureEnabled();
        var conservatoireFeatureEnabled = sm.portal.utility.isConservatoireFeatureEnabled();
        this.SummaryInfoMessageTemplate = ko.observable('');
        this.SetDemographicRequired = ko.observable(false);
        this.AcademicTemplateCustom = ko.observable(false);
        this.hidesummarybutton = ko.observable(false);
        this.hidePartialText = ko.observable(false);
        this.SubmissionText = ko.observable('SubmitApplication0WithReceiptAndInstructions');
        this.allCustomData = ko.observable('');
        this.isErrorMsgVisible = ko.observable(false);
        sm.portal.vm.custom.setCustomLocalizeKey(self);
        // Get AdmissionsStage and Milestones
        this.GetAdmissionsStage = function (applicationGID) {
            var url = _baseApiUri + 'api/StudentPortal/GetAdmissionsStage?gid=' + applicationGID;
            $.blockUI();

            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    if (!sm.portal.utility.isNullOrEmpty(data)) {
                        viewModel.AdmissionsStageID(data.Payload.AdmissionsStageID);
                        viewModel.Milestones(data.Payload.Milestones);
                    }
                    $.unblockUI();
                }
            });
        };

        this.LoadModel = function (container) {

            for (var i = 0; i < this.Sections().length; i++) {
                var section = this.Sections()[i];

                switch (section.SectionName()) {
                    case "BasicPerson":
                        if (container.Person != null) {
                            try {

                                section.SectionModel().FirstName(container.Person.GivenName);
                                section.SectionModel().MiddleName(container.Person.MiddleName);
                                section.SectionModel().LastName(container.Person.Surname);
                                var customSectionData = {
                                    Container: container,
                                    Person : Person,
                                    PreferredGivenName : PreferredGivenName,
                                    Section: section,
                                }
                                sm.portal.vm.custom.callCustomization('SetPreferedName', customSectionData);
                                section.SectionModel().DateOfBirth(container.Person.DateOfBirth);
                                section.SectionModel().GenderID(container.Person.GenderID);

                            } catch (e) { }
                        }
                        break;
                    case "BasicContact":
                        break;
                }

            }


        };

        this.HandleError = function (title, messages) {
            this.IsError(true);
            if (messages) {
                this.ErrorMessages(messages);
            }
            if (sm.portal.utility.isNullOrEmpty(title)) {
                this.ErrorHeader(sm.portal.utility.getResourceValue('ThereWasAnError'));
            } else {
                this.ErrorHeader(title);
            }
        };
        this.ThrowErrorWithRelevantMessage = function(data, action) {
            $.unblockUI();
            const userLoggedIn = viewModel && viewModel.GetSectionModel('Account') && viewModel.GetSectionModel('Account').IsLoggedIn();
            if (!viewModel.isErrorMsgVisible()) {
                viewModel.isErrorMsgVisible(true);
                let errorMessage = 'There is an error';
                if (userLoggedIn === true && action === 'save') {
                    if (data && data.status === 0) {
                        errorMessage = sm.portal.utility.getResourceValue('ErrorMessageOnSaveForInternet');
                    } else {
                        errorMessage = sm.portal.utility.getResourceValue('ErrorMessageOnSave');
                    }
                } else if (userLoggedIn === true && action === 'fetch') {
                    if (data && data.status === 0) {
                        errorMessage = sm.portal.utility.getResourceValue('ErrorMessageOnFetchForInternet');
                    } else {
                        errorMessage = sm.portal.utility.getResourceValue('ErrorMessageOnFetch');
                    }
                } else {
                    errorMessage = sm.portal.utility.getResourceValue('ErrorMessageNotLoggedIn');
                    // refresh page automatically
                }
                var title = sm.portal.utility.getResourceValue('Error');
                var body = errorMessage;
                var ok = sm.portal.utility.getResourceValue('OK');
                sm.portal.ui.lightBox(
                    title,
                    body,
                    'userCreationFailPopUp',
                    null,
                    null,
                    '<button id="confirmErrorMessage" class="confirmBtn" data-close-lightbox>' + ok + '</button>',
                    null,
                    null,
                    null,
                    'UserCreationFail',
                    null
                );
            }            
            jQuery('#confirmErrorMessage').click(function () {
                viewModel.isErrorMsgVisible(false);
                viewModel.autoRefresh(userLoggedIn);
            });
        }

        this.autoRefresh = function(userLoggedIn) {
            if (userLoggedIn) {
                return;
            }
            location.reload();
        }

        this.AppendNotExistingWarnings = function (newWarnings) {
            if (!newWarnings)
                return;

            for (var i = 0; i < newWarnings.length; i++) {
                if (this.WarningMessages.indexOf(newWarnings[i]) == -1) {
                    this.WarningMessages.push(newWarnings[i]);
                }
            }
        };

        this.UpdateTermsSections = function () {

            for (var i = 0; i < this.Sections().length; i++) {
                var section = this.Sections()[i];

                switch (section.SectionName()) {
                    case "BeforeTerms":
                    case "AfterTerms":
                        var model = section.SectionModel();
                        section.Applied(model.ShouldDisplay());
                        section.Required(model.IsRequired());
                        break;
                }

            }
        };

        this.DataTestMode = ko.observable(false);
        sm.portal.vm.custom.callCustomization('UpdateTermsSectionsProp', self);

        /**
         * Method to get viewmodel data
         * This will wait until all viewmodel API data is retrieved
         * @param {object} sectionModel 
         * @param {boolean} blockui 
         * @param {string} applicationMID 
         * @param {string} personMID 
         */
        this.GetModelDataWrapper = function (sectionModel, blockui, applicationMID, personMID) {
            return new Promise(function (resolve) {
                sectionModel.GetModelData(blockui, applicationMID, personMID, function () {
                    resolve();
                });
            });
        };

        this.IsExceptionalSection = function(ctx){
            let secArr = ['Account','BeforeTerms','ApplicationInformation','AfterTerms','HighSchool'];
            return secArr.includes(ctx);
        }

        this.ConstructData = function(data){
            var fullAttempt = data.CompositePayload.FullAttempt.FullAttempt;
            var arr = [];
            let allListdata = {};
            if(sm.portal.utility.EnableU4smPortalStaticdataService()){
                allListdata = self.getListData('');
            }
            var obj = {};
            for (const [key, value] of Object.entries(data.CompositePayload)) {
                if(key=="accountSection"){
                    obj["Account"] = {};
                    obj.Account["Payload"] = value;
                    obj.Account.Payload["FullAttempt"]= fullAttempt;
                }
                if(key=="contactSection"){
                    obj["BasicContact"] = {};
                    obj.BasicContact["Payload"] = value;
                    obj.BasicContact.Payload["FullAttempt"]= fullAttempt;
                    if(sm.portal.utility.EnableU4smPortalStaticdataService()){
                        obj.BasicContact.Payload.ListData = allListdata.contact.ListData;
                    }
                   
                }
                
                if(key=="beforetermsSection"){
                    obj["BeforeTerms"] = {};
                    obj.BeforeTerms["Payload"] = value;
                    obj.BeforeTerms.Payload["FullAttempt"]= fullAttempt;
                }
                if(key=="aftertermsSection"){
                    obj["AfterTerms"] = {};
                    obj.AfterTerms["Payload"] = value;
                    obj.AfterTerms.Payload["FullAttempt"]= fullAttempt;
                }
                if(key=="demographicSection"){
                    obj["Demographic"] = {};
                    obj.Demographic["Payload"] = value;
                    obj.Demographic.Payload["FullAttempt"]= fullAttempt;
                    if(sm.portal.utility.EnableU4smPortalStaticdataService()){
                        obj.Demographic.Payload.ListData = allListdata.demographic.ListData;
                    }
                    
                }
                //Employment
                if(key=="employmentSection"){
                    obj["Employment"] = {};
                    obj.Employment["Payload"] = value;
                    obj.Employment.Payload["FullAttempt"]= fullAttempt;
                    if(sm.portal.utility.EnableU4smPortalStaticdataService()){
                        obj.Employment.Payload.ListData = allListdata.employment.ListData;
                    }
                    
                }
                if(key=="highschoolSection"){
                    obj["HighSchool"] = {};
                    obj.HighSchool["Payload"] = value;
                    obj.HighSchool.Payload["FullAttempt"]= fullAttempt;
                    if(sm.portal.utility.EnableU4smPortalStaticdataService()){
                        obj.HighSchool.Payload.ListData = allListdata.highschool.ListData;
                    }
                    
                }
                if(key=="personSection"){
                    //BasicPerson
                    obj["BasicPerson"] = {};
                    obj.BasicPerson["Payload"] = value;
                    obj.BasicPerson.Payload["FullAttempt"]= fullAttempt;
                    if(sm.portal.utility.EnableU4smPortalStaticdataService()){
                        obj.BasicPerson.Payload.ListData = allListdata.person.ListData;
                    }
                    
                }
                // //academicSection
                if(key=="academicSection"){
                    obj["Academic"] = {};
                    obj.Academic["Payload"] = value;
                    obj.Academic.Payload["FullAttempt"]= fullAttempt;
                    if(sm.portal.utility.EnableU4smPortalStaticdataService()){
                        obj.Academic.Payload.ListData = allListdata.academic.ListData;
                    }
                   
                }
                //QualificationsOnEntry
                if(key=="qualificationsSection"){
                    obj["QualificationsOnEntry"] = {};
                    obj.QualificationsOnEntry["Payload"] = value;
                    obj.QualificationsOnEntry.Payload["FullAttempt"]= fullAttempt;
                    if(sm.portal.utility.EnableU4smPortalStaticdataService()){
                        obj.QualificationsOnEntry.Payload.ListData = allListdata.qualifications.ListData;
                    }
                   
                }
                //
                if(key=="languagesSection"){
                    obj["Languages"] = {};
                    obj.Languages["Payload"] = value;
                    obj.Languages.Payload["FullAttempt"]= fullAttempt;
                    if(sm.portal.utility.EnableU4smPortalStaticdataService()){
                        obj.Languages.Payload.ListData = allListdata.languages.ListData;
                    }
                    
                }
                if(key=="accessibilityneedSection"){
                    obj["AccessibilityNeed"] = {};
                    obj.AccessibilityNeed["Payload"] = value;
                    obj.AccessibilityNeed.Payload["FullAttempt"]= fullAttempt;
                    if(sm.portal.utility.EnableU4smPortalStaticdataService()){
                        obj.AccessibilityNeed.Payload.ListData = allListdata.accessibilityneed.ListData
                    }
                    
                }
                if(key=="applicationinformationSection"){
                    obj["ApplicationInformation"] = {};
                    obj.ApplicationInformation["Payload"] = value;
                    obj.ApplicationInformation.Payload["FullAttempt"]= fullAttempt;
                    if(sm.portal.utility.EnableU4smPortalStaticdataService()){
                        obj.ApplicationInformation.Payload.ListData = allListdata.applicationinformation.ListData;
                    }
                    
                }
            
            }
            return obj;
        }
       
        this.getListData = function(sectionName){
            var url = sm.portal.utility.U4smPortalStaticdataServiceURL()+"applynow/allsectionportalstaticdata.json";
              
            let listData = {};
            
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                async: false,
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' ,
                    "TenantGID": sm.portal.utility.isTenantAvailable(),
                },
                processData: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    listData =  data.CompositePayload;
                }
            });
            return listData;
        }

        this.GetAllSection = function(mid){
            var data_all = {};
            var url = _baseApiUri + 'api/studentportal/GetApplicationAllSection?attemptMID=' + mid;
            $.blockUI();
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                async: false,
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    data_all = self.ConstructData(data);
                    $.unblockUI();
                }
            });
            return data_all;
        }

        // Entry Point Initialization methods
        this.Initialize = function (applicationGID, personGID) {
            var isReturning = false;
            var isUser = false;
            // Store the Existing GID if it's there...
            if (!sm.portal.utility.isNullOrEmpty(applicationGID)) {
                this.GetAdmissionsStage(applicationGID);
                this.ApplicationGID(applicationGID);
                this.ShowPartialPopup(false); // This is a specific application, don't show the Partial application popup
                isReturning = true;
            }

            // Store the Person GID if it's there...
            if (!sm.portal.utility.isNullOrEmpty(personGID)) {
                this.PersonGID(personGID);
                isUser = true;
            }

            if (!sm.portal.utility.isNullOrEmpty(_currentPersonId) && _currentPersonId > 0) {
                this.PersonID(_currentPersonId);
                isUser = true;
            }

            if(!sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization('loadConsolidatedTemplates'))){
                var allData = self.GetAllSection(applicationGID);
                self.allCustomData(allData);
            }

            // Set the Starting Point for the Sections.
            var startingPoint = this.InitializeSections();

            var sectionModelArray = [];
            // Start the Data Loading Process
            for (var i = 0; i < viewModel.Sections().length; i++) {
                if(viewModel.Sections()[i].SectionName() == 'HighSchool') {
                    self.getHighSchoolIndex(i);
                }
                if(viewModel.Sections()[i].SectionName() == 'Summary') {
                    self.getSummaryIndex(i);
                }
                if(viewModel.Sections()[i].SectionName() == 'Academic') {
                    self.getAcademicIndex(i);
                }
                if(!sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization('loadConsolidatedTemplates'))){
                    if(user_id == 0 && self.IsExceptionalSection(viewModel.Sections()[i].SectionName())) {
                        var nextSection = viewModel.Sections()[i];
                        if (!sm.portal.utility.isNullOrEmpty(nextSection.SectionModel()) && !nextSection.SectionModel().DataLoaded() && !nextSection.SectionModel().DataLoading()) {
                            if (smapi.constant.applicationDebugFlag) { console.log('[SectionModel.Activate] Background Loading ' + nextSection.SectionName()); }
                            var customData = {
                                NextSection : nextSection,
                                ApplicationMID : this.ApplicationMID(),
                                PersonMID : this.PersonMID(),
                            }
                            var isCustomized = sm.portal.vm.custom.callCustomization('GetModelDataForNextSection', customData);
                            if(!isCustomized){
                                sectionModelArray.push(self.GetModelDataWrapper(nextSection.SectionModel(), false, this.ApplicationMID(), this.PersonMID()));                   
                            }
                        }
                    } else {
                        if(user_id > 0) {
                            var nextSection = viewModel.Sections()[i];
                            if (!sm.portal.utility.isNullOrEmpty(nextSection.SectionModel()) && !nextSection.SectionModel().DataLoaded() && !nextSection.SectionModel().DataLoading()) {
                                if (smapi.constant.applicationDebugFlag) { console.log('[SectionModel.Activate] Background Loading ' + nextSection.SectionName()); }
                                var customData = {
                                    NextSection : nextSection,
                                    ApplicationMID : this.ApplicationMID(),
                                    PersonMID : this.PersonMID(),
                                }
                            
                                    var isCustomized = sm.portal.vm.custom.callCustomization('GetModelDataForNextSection', customData);
                                    if(!isCustomized){
                                        sectionModelArray.push(self.GetModelDataWrapper(nextSection.SectionModel(), false, this.ApplicationMID(), this.PersonMID()));                   
                                    }
                            
                            }
                        }
                    }
                }else{
                    var nextSection = viewModel.Sections()[i];
                    if (!sm.portal.utility.isNullOrEmpty(nextSection.SectionModel()) && !nextSection.SectionModel().DataLoaded() && !nextSection.SectionModel().DataLoading()) {
                        if (smapi.constant.applicationDebugFlag) { console.log('[SectionModel.Activate] Background Loading ' + nextSection.SectionName()); }
                        var customData = {
                            NextSection : nextSection,
                            ApplicationMID : this.ApplicationMID(),
                            PersonMID : this.PersonMID(),
                        }
                        var isCustomized = sm.portal.vm.custom.callCustomization('GetModelDataForNextSection', customData);
                        if(!isCustomized){
                            sectionModelArray.push(self.GetModelDataWrapper(nextSection.SectionModel(), false, this.ApplicationMID(), this.PersonMID()));                   
                        }
                    }
                }
            }
            // Sort the array based on admin configuration
            var retainCustomAppearance  = sm.portal.vm.custom.callCustomization('RetainCustomAppearance');
            if(!retainCustomAppearance){
                Promise.all(sectionModelArray).then(function () {
                    self.Sections().sort(function (a, b) {
                        return a.AppearanceOrder() - b.AppearanceOrder();
                    });
                    self.Sections.valueHasMutated();
                });
            }


            // Set the Current to the first
            this.ActiveSectionChanged(startingPoint);

            // Show the Splash Screen if needed     // TODO: Finish this to look good if we want a splash screen.
            if (this.ShowSplashScreen()) {
                // Dialog the splash screen div...
                $("#smApplicationSplash").dialog({
                    width: 600,
                    height: 400,
                    modal: true,
                    buttons: {
                        Ok: function () {
                            $(this).dialog("close");
                        }
                    }
                });
            }

            // if we have an application gid, then grab the username and switch to the login form
            var applicationViewModel = this;
            var section = applicationViewModel.GetSectionModel('Account');

            if (!sm.portal.utility.isNullOrEmpty(applicationGID) && !sm.portal.utility.isNullOrEmpty(personGID) && !section.IsLoggedIn()) {
                var url = _baseApiUri + 'api/StudentPortal/GetUserFromAttempt?admissionsAttemptGID=' + applicationGID + '&personGID=' + personGID;
                $.blockUI();
                $.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        if (!sm.portal.utility.isNullOrEmpty(data)) {
                            section.ToggleLogin();
                            section.LoginUserName(data);
                        }
                        $.unblockUI();
                    }
                });
            }

            if (isReturning) {
                setTimeout(function () {
                    console.log('checking initially');
                    viewModel.CheckSectionsForInclusion();
                }, 1000);

            }
        };       
        this.InitializeSections = function () {

            if (smapi.constant.applicationDebugFlag) { console.log('[InitializeSections] Firing'); }
            
            // Models defined in order to take advantage of Test Mode Data
            var accountModel = new sm.portal.vm.AccountViewModel();
            var personModel = new sm.portal.vm.PersonalInformationViewModel({ getTaxIdRegex: true });
            var contactModel = new sm.portal.vm.BasicContactViewModel();
            var academicModel = new sm.portal.vm.AcademicInterestsViewModel();
            var demographicModel = new sm.portal.vm.DemographicViewModel();
            var employmentModel = new sm.portal.vm.EmploymentViewModel();
            var collegeModel = new sm.portal.vm.PreviousCollegeViewModel();
            var highSchoolModel = new sm.portal.vm.PreviousHighSchoolViewModel();
            var testscoreModel = new sm.portal.vm.PlacementTestViewModel();
            var beforeTermsModel = new sm.portal.vm.TermsConditionsViewModel("BeforeTerms", "BeforeTermsContainer", this);
            var afterTermsModel = new sm.portal.vm.TermsConditionsViewModel("AfterTerms", "AfterTermsContainer", this);

            // Trigger the Partial lookup if the PersonGID is Set
            accountModel.PersonGID.subscribe(function (newValue) {
                self.HandlePartialApplications(newValue);
            });

            //Force account section to be true
            accountModel.IsRequired(true);

            // Account Setup
            accountModel.IsUserLoggedIn();  // Trigger the initialization of the Account Model - Special Case.

            // TEST DATA
            if (this.DataTestMode()) {
                // This is where you can set up test data if you want to run through the app faster.
            }

            /** ---Appearance Order---
             * The appearance order will be multiplied by 10
             * for all core sections. This will give localization
             * packages the ability to insert their own sections
             * between the exisitng core sections.
              */
            var appearanceOrder = -1;

            var startingPoint = new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: "Account",
                SectionTitle: sm.portal.utility.getResourceValue('AccountInformation'),
                SectionNavTitle: sm.portal.utility.getResourceValue('Account'),
                Applied: true,
                Required: true,
                SectionModel: accountModel,
                SectionTemplate: "AccountTemplate",
                Active: true
            });

            // Initial Section

            this.Sections.push(startingPoint);

            var coreSection = [];
            // Terms and Conditions Before Section
            coreSection.push(new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: 'BeforeTerms',
                SectionTitle: sm.portal.utility.getResourceValue('BeforeTerms'),
                SectionNavTitle: sm.portal.utility.getResourceValue('BeforeTerms'),
                Applied: false,
                Required: false,
                Completed: false,
                SectionModel: beforeTermsModel,
                SectionTemplate: "BeforeTermsTemplate",
            }));

            // Personal
            coreSection.push(new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: 'BasicPerson',
                SectionTitle: sm.portal.utility.getResourceValue('PersonalInformation'),
                SectionNavTitle: sm.portal.utility.getResourceValue('Personal'),
                Applied: true,
                Required: true,
                SectionModel: personModel,
                SectionTemplate: "BasicPersonTemplate",
                Active: true
            }));

            // Contact
            coreSection.push(new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: 'BasicContact',
                SectionTitle: sm.portal.utility.getResourceValue('ContactDetails'),
                SectionNavTitle: sm.portal.utility.getResourceValue('Contact'),
                Applied: true,
                Required: true,
                SectionModel: contactModel,
                SectionTemplate: "BasicContactTemplate"
            }));
           
            // Academic Interests                    
            coreSection.push(new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: 'Academic',
                SectionTitle: sm.portal.utility.getResourceValue('AcademicGoals'),
                SectionNavTitle: sm.portal.utility.getResourceValue('Academic'),
                Applied: true,
                Required: true,
                SectionModel: academicModel,
                SectionTemplate: "AcademicTemplate"
            }));

            // Demographic Information
            coreSection.push(new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: 'Demographic',
                SectionTitle: sm.portal.utility.getResourceValue('DemographicInformation'),
                SectionNavTitle: sm.portal.utility.getResourceValue('Demographic'),
                Applied: true,
                Required: self.SetDemographicRequired(),
                SectionModel: demographicModel,
                SectionTemplate: "DemographicTemplate"
            }));

            // Employment Information
            coreSection.push(new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: 'Employment',
                SectionTitle: sm.portal.utility.getResourceValue('EmploymentDetails'),
                SectionNavTitle: sm.portal.utility.getResourceValue('Employment'),
                Applied: true,
                Completed: false,
                Required: false,
                SectionModel: employmentModel,
                SectionTemplate: "EmploymentTemplate"
            }));

            // Previous High School
            coreSection.push(new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: 'HighSchool',
                SectionTitle: sm.portal.utility.getResourceValue('HighSchool'),
                SectionNavTitle: sm.portal.utility.getResourceValue('HighSchool'),
                Required: true,
                SectionModel: highSchoolModel,
                SectionTemplate: "HighSchoolTemplate"
            }));
           
            // Previous College
            coreSection.push(new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: 'College',
                SectionTitle: sm.portal.utility.getResourceValue('PreviousCollege'),
                SectionNavTitle: sm.portal.utility.getResourceValue('College'),
                Required: false,
                SectionModel: collegeModel,
                SectionTemplate: "CollegeTemplate"
            }));

            // Test Scores
            coreSection.push(new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: 'TestScore',
                SectionTitle: sm.portal.utility.getResourceValue('TestScores'),
                SectionNavTitle: sm.portal.utility.getResourceValue('TestScores'),
                Required: false,
                SectionModel: testscoreModel,
                SectionTemplate: "TestScoreTemplate"
            }));

            this.LastSectionName('TestScore');


            // Terms and Conditions After Section
            coreSection.push(new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: 'AfterTerms',
                SectionTitle: sm.portal.utility.getResourceValue('AfterTerms'),
                SectionNavTitle: sm.portal.utility.getResourceValue('AfterTerms'),
                Applied: false,
                Required: false,
                Completed: false,
                SectionModel: afterTermsModel,
                SectionTemplate: "AfterTermsTemplate"
            }));

            var summarySection = new sm.portal.vm.ApplicationSectionModel({
                AppearanceOrder: ((++appearanceOrder) * 10),
                SectionName: 'Summary',
                SectionTitle: sm.portal.utility.getResourceValue('Summary'),
                SectionNavTitle: sm.portal.utility.getResourceValue('Summary'),
                Applied: true,
                Required: true,
                Completed: false,
                SectionModel: new sm.portal.vm.SummaryViewModel(),
                SectionTemplate: "SummaryTemplate"
            });

            coreSection.push(summarySection);
            this.SummarySection(summarySection);
            var section = sm.portal.vm.custom.callCustomization('RemoveEmplymentSection', coreSection);
            if (section != undefined) {
                coreSection = section;
            }

            if (typeof sm.portal.vm.ukapplication !== 'undefined' && ukFeatureEnabled) {
                coreSection = sm.portal.vm.ukapplication.InitializeSections(this, coreSection);
            } else if (typeof sm.portal.vm.euapplication !== 'undefined' && euFeatureEnabled) {
                coreSection = sm.portal.vm.euapplication.InitializeSections(this, coreSection);
            } else if (typeof sm.portal.vm.apasapplication !== 'undefined' && apasFeatureEnabled) {
                coreSection = sm.portal.vm.apasapplication.InitializeSections(this, coreSection);
            }

            if (typeof sm.portal.vm.conservatoireapplication !== 'undefined' && conservatoireFeatureEnabled) {
                coreSection = sm.portal.vm.conservatoireapplication.InitializeSections(this, coreSection);
            }

            sm.portal.vm.custom.callCustomization('UpdateSections',coreSection);

            coreSection.sort(function (a, b) { return a.AppearanceOrder() - b.AppearanceOrder(); });
            this.Sections(self.Sections().concat(coreSection));

            return startingPoint;
        };
        this.MaintainSections = function (sectionsToAdd, sectionsToRemove) {
            if (sectionsToAdd != null && sectionsToAdd != undefined) {

                // Loop through the sections, updating the Applied value.
                for (var j = 0; j < sectionsToAdd.length; j++) {
                    var addObj = sectionsToAdd[j];

                    for (var i = 0; i < this.Sections().length; i++) {
                        if (this.Sections()[i].SectionName() == addObj.section) {
                            if (smapi.constant.applicationDebugFlag) { console.log('Applying Section ' + addObj.section); }

                            this.Sections()[i].Applied(true);
                            this.Sections()[i].Required(addObj.required);

                            // This would be a great spot to refresh any caches from the services
                            if (!this.Sections()[i].SectionModel().DataLoaded() && !this.Sections()[i].SectionModel().DataLoading()) {
                                this.Sections()[i].SectionModel().GetModelData(false, this.ApplicationMID(), this.PersonMID());
                            }

                            if (this.Sections()[i].SectionModel().UpdateData != undefined && this.Sections()[i].SectionModel().UpdateData()) {
                                this.Sections()[i].SectionModel().GetModelData(false, this.ApplicationMID(), this.PersonMID());
                            }
                        }
                    }
                }
            }
            if (sectionsToRemove != null && sectionsToRemove != undefined) {
                for (var j = 0; j < sectionsToRemove.length; j++) {
                    for (var i = 0; i < this.Sections().length; i++) {
                        if (this.Sections()[i].SectionName() == sectionsToRemove[j]) {
                            if (smapi.constant.applicationDebugFlag) { console.log('Un-Applying Section ' + sectionsToRemove[j]); }
                            this.Sections()[i].Applied(false);
                            this.Sections()[i].Required(false); // If it's not applied, it's not required - issue on Graduate Level apps for High School...
                        }
                    }
                }
            }
        };

        // Helper Properties
        this.TemplatesLoaded = ko.observable(false);
        this.BaseU4SMUrl = ko.observable();
        this.ShowPartialData = ko.observable(false);
        this.ShowPartialPopup = ko.observable(true);

        // Application Properties
        this.ApplicationID = ko.observable();
        this.ApplicationGID = ko.observable();
        this.PersonID = ko.observable();
        this.PersonGID = ko.observable();
        this.ApplicationMID = ko.computed(function () {
            if (!sm.portal.utility.isNullOrEmpty(this.ApplicationGID())) {
                return this.ApplicationGID();
            } else if (!sm.portal.utility.isNullOrEmpty(this.ApplicationID())) {
                return this.ApplicationID();
            }
            return "";
        }, this);
        this.PersonMID = ko.computed(function () {

            if (!sm.portal.utility.isNullOrEmpty(this.PersonGID())) {
                return this.PersonGID();
            } else if (!sm.portal.utility.isNullOrEmpty(this.PersonID())) {
                return this.PersonID();
            }
            return "";
        }, this);

        this.AdmissionsStageID = ko.observable();
        this.Milestones = ko.observableArray();
        this.DisclaimerText = ko.observable();
        this.IsDisclaimerTextEmpty = ko.observable(false);
        
        // Section Properties
        this.CurrentSection = ko.observable();
        this.SummarySection = ko.observable();
        this.LastSectionName = ko.observable();
        this.ShowSplashScreen = ko.observable(false);       // TODO: If we want to implement a splash screen dialog, change this to TRUE and look inside this.Initialize();
        this.IsCreateUserProcessRunning = ko.observable(false);

        // App Fee Notification Properties
        this.HasApplicationFee = ko.observable(false);
        this.ApplicationFeeRequired = ko.observable(false);
        this.AdmissionsAcademicLevelFees = ko.observableArray();
        this.ShowUserCreatedNotification = ko.observable(false);

        // Results
        this.Saved = ko.observable(false);
        this.Saving = ko.observable(false);
        this.HasBeenSaved = ko.observable();
        this.Submitted = ko.observable(false);
        this.Result_PersonGivenName = ko.observable();
        this.IsPaymentProviderEnabled = ko.observable(false);
        this.PaymentProviderName = ko.observable();
        this.PaymentDetails = ko.observable();
        this.WarningMessages = ko.observableArray();
        sm.portal.vm.custom.callCustomization('UpdateProps', self);
        sm.portal.vm.custom.callCustomization('PebblePadFunctionality', self);

        //Domicile related observables
        this.IsBillingDomicileMappingCorrect = ko.observable(false);
        this.BillingDomicileMessage = ko.observable("");
        this.IsBillingDomicilePaymentProviderEnabled = ko.observable(false);
        this.BillingDomicilePaymentProviders = ko.observableArray();
        this.PartialPaymentAmount = ko.observable();
        this.MinimumAmountForPayments = ko.observable();
        this.EnablePartialPayment = ko.observable();
        this.PaymentProviderID = ko.observable();

        //Post submission flow settings observables
        this.ApplicationFee = ko.observableArray();
        this.SubmittedWithPostSubmissionFlowCustom = ko.observable(false);

        // Calculated Sections Properties - Identifies what sections are required, and what has been handled
        this.Sections = ko.observableArray();
        this.AppliedSections = ko.computed(function () {
            var results = Array();

            for (var i = 0; i < this.Sections().length; i++) {

                if (this.Sections()[i].Applied() == true) {
                    results.push(this.Sections()[i]);
                }
            }

            return results;
        }, this);

        this.UnappliedSections = ko.computed(function () {
            var results = Array();

            for (var i = 0; i < this.Sections().length; i++) {

                if (this.Sections()[i].Applied() != true) {
                    results.push(this.Sections()[i]);
                }
            }

            return results;
        }, this);
        this.CompletedSections = ko.computed(function () {
            var results = Array();

            for (var i = 0; i < this.Sections().length; i++) {
                if (this.Sections()[i].Applied() == true && this.Sections()[i].Completed() == true) {
                    results.push(this.Sections()[i]);
                }
            }

            return results;
        }, this);
        this.IncompleteSections = ko.computed(function () {
            var results = Array();

            for (var i = 0; i < this.Sections().length; i++) {

                if (this.Sections()[i].Applied() == true && this.Sections()[i].Completed() != true) {
                    results.push(this.Sections()[i]);
                }
            }

            return results;
        }, this);

        // Summary sections having applied sections only
        this.SummarySections = ko.computed(function () {
            var results = Array();
            var appliedSections = this.AppliedSections();
            for (var i = 0; i < appliedSections.length; i++) {
                var section = appliedSections[i];
                if (section.SectionName() !== "Account" && section.SectionName() !== "Summary") {
                    results.push(appliedSections[i]);
                }
            }
            return results;
        }, this);

        // Current Section Computed Properties
        this.CurrentSectionName = ko.computed(function () {
            if (sm.portal.utility.isNullOrEmpty(this.CurrentSection())) {
                return "";
            }
            return this.CurrentSection().SectionName();
        }, this);

        this.CurrentSectionClass = ko.computed(function () {
            if (sm.portal.utility.isNullOrEmpty(this.CurrentSection())) {
                return "";
            }

            var stageName = this.CurrentSection().SectionName() + "";
            return "stage-" + stageName.toLowerCase() + "";
        }, this);

        this.IsCurrentSectionSeen = ko.computed(function () {
            if (sm.portal.utility.isNullOrEmpty(this.CurrentSection())) {
                return false;
            }

            return this.CurrentSection().Seen();
        }, this);

        this.IsCurrentSectionSeenClass = ko.computed(function () {

            if (this.IsCurrentSectionSeen()) {
                return "section-seen";
            }

            return "section-unseen";

        }, this);

        this.CurrentSectionTitle = ko.computed(function () {
            if (sm.portal.utility.isNullOrEmpty(this.CurrentSection())) {
                return "";
            }
            return this.CurrentSection().SectionTitle();
        }, this);
        this.CurrentSectionCount = ko.computed(function () {
            if (sm.portal.utility.isNullOrEmpty(this.CurrentSection())) {
                return "";
            }
            return sm.portal.utility.formatString("{0} of {1}", this.CurrentSection().SectionIndex(), this.AppliedSections().length);
        }, this);
        this.SubmitAvailable = ko.computed(function () {

            if (smapi.constant.applicationDebugFlag) { return true; }

            for (var i = 0; i < this.AppliedSections().length; i++) {
                if (this.AppliedSections()[i].SectionName() != "Summary"
                    && (this.AppliedSections()[i].Required() == true && this.AppliedSections()[i].Completed() != true)) {
                    return false;
                }
            }
            return true;

        }, this);
        this.SummaryVisible = ko.computed(function () {
            return this.CurrentSectionName() == "Summary";
        }, this);
        this.SummaryAvailable = ko.computed(function () {
            if (smapi.constant.applicationDebugFlag) { return true; }
      
            var results = Array();
            for (var i = 0; i < this.Sections().length; i++) {
              if (this.Sections()[i].SectionName() != 'Summary' &&
                          (this.Sections()[i].Required() == true && this.Sections()[i].Completed() != true)) {
                return false;
              }
            }
            return true;
          }, this);
        this.ApplicationFeeMessageShown = ko.computed(function () {

            if (!this.HasApplicationFee()) {
                return false;
            }

            if (this.HasApplicationFee()) {
                if (this.CurrentSectionName() == "Account") {
                    return true;
                }
                return false;
            }
            return false;
        }, this);
        this.ApplicationFeeAmount = ko.computed(function () {
            var msg = "";
            var feeCount = this.AdmissionsAcademicLevelFees().length;

            for (i = 0; i < feeCount; i++) {
                msg += this.AdmissionsAcademicLevelFees()[i];

                if (i !== feeCount - 1) {
                    msg += ", ";
                }
            }

            return msg;
        }, this);

        this.firstLoad = ko.observable(true);
        this.getHighSchoolIndex = ko.observable(0);
        this.getSummaryIndex = ko.observable(0);
        this.getAcademicIndex = ko.observable(0);

        // Event Change Handler
        this.ActiveSectionChanged = function (activeSection) {

            var workspace = $("#TestContainer");
            if (workspace.length > 0) {
                workspace.block({ message: sm.portal.utility.getResourceValue('Loading') });
                $("div.blockUI.blockMsg.blockElement").show();
            }

            // Set the Previous Section
            var previousSection = this.CurrentSection();

            if (previousSection && !previousSection.Seen()) {
                previousSection.Seen(true);
            }      

            var customData = {
                PreviousSection: previousSection,
                ActiveSection: activeSection,
                self : self,
                workspace : workspace
            }
           
            var nextSection = sm.portal.vm.custom.callCustomization('UpdateActiveSectionChanged', customData);

            if(!sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization('loadConsolidatedTemplates'))){
                if(!sm.portal.utility.isNullOrEmpty(previousSection)) {
                    if(parseInt(previousSection.SectionIndex()) + 1 == self.getSummaryIndex()) {
                        this.Sections()[self.getSummaryIndex()].SectionModel().GetModelData(false, this.ApplicationMID(), this.PersonMID());
                    }
                    if(parseInt(previousSection.SectionIndex()) + 1 == self.getAcademicIndex()) {
                        this.Sections()[self.getAcademicIndex()].SectionModel().GetModelData(false, this.ApplicationMID(), this.PersonMID());
                    }
                }
            }
            
            if(!sm.portal.utility.isNullOrEmpty(nextSection)){
                return false;
            }
            // Background process any server actions for the previous section
            if (previousSection != null && previousSection.Completed()) {
                try {
                    previousSection.SectionModel().ProcessOnServer();
                } catch (e) { }
            }

            // Send the Application to the Server for in-process caching/saving
            try {
                this.PerformApplicationAutoSave();
            } catch (e) {
                var cusdata = {                        
                    viewModel : viewModel,
                    e : e
                }
                 //Required console to check which section throws an error
                console.log("error is===>" + e.message);
                sm.portal.vm.custom.callCustomization('UpdateIsUserCreateProp', cusdata);
             }

            // Find the Current Section in the list
            var currentSection = null;
            for (var i = 0; i < this.Sections().length; i++) {

                if (this.Sections()[i].SectionName() != activeSection.SectionName()) {
                    this.Sections()[i].Active(false);
                }
            }

            // Set the Current Section
            this.CurrentSection(activeSection);
            this.CurrentSection().Activate();

            setTimeout(function () {
                if (workspace.length > 0) {
                    workspace.unblock();
                }
            }, 500);


            if (this.firstLoad() == false) {
                jQuery('html,body').animate({
                    scrollTop: jQuery('.smContentArea').offset().top
                }, 500);
            }
            else {
                this.firstLoad(false);
            }

            if (activeSection.SectionName() !== "TestScore") {
                $("#cancelACTItem").trigger("click");
                $("#cancelSATItem").trigger("click");
            }

            if (activeSection.SectionName() === "Academic" && activeSection.SectionModel().FirstLoad()) {

                ko.validation.group(activeSection.SectionModel()).showAllMessages(false);
                activeSection.SectionModel().FirstLoad(false);
            }

            if (activeSection.SectionName() === "BasicContact") {
                activeSection.SectionModel().Display();
            }
            var custData = {
                previousSection : previousSection,
                self : self
            }
            sm.portal.vm.custom.callCustomization('ResetProgrammeCategory', custData);
        };

        // Loads data between Sections
        this.LoadChildData = function (target, property, data) {

            // Find the matching Target
            for (var i = 0; i < this.Sections().length; i++) {
                if (this.Sections()[i].SectionName() == target) {

                    // Attempt to set the Property via Eval
                    try {
                        var cmd = "this.Sections()[i].SectionModel()." + property + "(data);";
                        eval(cmd);

                    } catch (e) {
                        if (smapi.constant.applicationDebugFlag) { console.log('Problem setting Child Data for ' + target + ', ' + property + ': ' + e.message); }
                    }
                    break;
                }
            }
        };
        // Retrieves the specified Section's application section model
        this.GetApplicationSectionModel = function (sectionName) {
            var appSectionModel = null;
            for (var i = 0; i < self.Sections().length; i++) {
                if (self.Sections()[i].SectionName() == sectionName) {
                    appSectionModel = self.Sections()[i];
                    break;
                }
            }
            return appSectionModel;
        };

        // Retrieves the specified Section's model
        this.GetSectionModel = function (sectionName) {

            var sectionModel = null;
            for (var i = 0; i < self.Sections().length; i++) {
                if (self.Sections()[i].SectionName() == sectionName) {
                    sectionModel = self.Sections()[i].SectionModel();
                    break;
                }
            }
            return sectionModel;
        };
        this.GetSectionTitle = function (sectionName) {

            var sectionTitle = null;
            for (var i = 0; i < self.Sections().length; i++) {
                if (self.Sections()[i].SectionName() == sectionName) {
                    sectionTitle = self.Sections()[i].SectionTitle();
                    break;
                }
            }
            return sectionTitle;
        };
        this.GetSectionNavClass = function (sectionName) {

            var sectionNavClass = null;
            for (var i = 0; i < self.Sections().length; i++) {
                if (self.Sections()[i].SectionName() == sectionName) {
                    sectionNavClass = self.Sections()[i].NavigationClass();
                    break;
                }
            }
            return sectionNavClass;
        };

        // Loads the Data from the Sections into the Summary
        this.LoadSummaryData = function () {
            var summaryDataModel = this.SummarySection().SectionModel();

            for (var i = 0; i < this.AppliedSections().length; i++) {
                var theName = this.AppliedSections()[i].SectionName();
                var theData = this.AppliedSections()[i].SectionModel();
                // Academic section available options data is not fetched at the load of page
                // Get academic section data from GetAdmissionsOfferingMatrix API 
                // if admissions attempt present but options not present
                if(theName == 'Academic' && theData.AdmissionsProgramID() && !theData.AdmissionsPrograms().length){
                    this.AppliedSections()[i].SectionModel().Initialize();
                }

                summaryDataModel.LoadSection(this.AppliedSections()[i].SectionName(), this.AppliedSections()[i].SectionModel());
            }
            summaryDataModel.LoadModel(null);
            jQuery('.sectionLink').first().focus();
        };

        // Navigates to a specific Section via Summary Page.
        this.NavigateToSection = function (sectionName) {
            var matched = null;
            for (var i = 0; i < this.AppliedSections().length; i++) {
                if (this.AppliedSections()[i].SectionName() == sectionName) {
                    matched = this.AppliedSections()[i];
                    break;
                }
            }
            var customData = {
                matched : matched,
                self : self
            }
            var res = sm.portal.vm.custom.callCustomization('CustomNavigateToSection', customData);
            if(sm.portal.utility.isNullOrEmpty(res)){
                if (matched != null && this.CanAdvanceAfterTerms(this.CurrentSection())) {
                    this.ActiveSectionChanged(matched);
                }
            }
            
        };
        // Update the sections configuration data
        this.SetSectionsConfigData = function (sectionName, configData, isDynamicSection) {
            if (sectionName && configData) {
                var appSection = this.GetApplicationSectionModel(sectionName);
                appSection && appSection.SetSectionsConfigData(configData, isDynamicSection);
            }
        }

        // Triggers the Form Validation setup for dynamic bits
        this.SetRequired = function () {
            if (!sm.portal.utility.isNullOrEmpty(this.CurrentSection())) {
                this.CurrentSection().Required();
            }
        };

        this.CanAdvanceAfterTerms = function (section) {
            // Check for Terms and Conditions should the pop-up be shown
            if (section != null && section.Applied()
                && (section.SectionName() == "BeforeTerms" || section.SectionName() == "AfterTerms")) {

                if (!section.Completed()) {
                    var title = sm.portal.utility.getResourceValue('Warning');
                    var body = sm.portal.utility.getResourceValue('TermsNotAccepted');

                    sm.portal.ui.lightBox(title, body, ' smallDialog');
                    return false;
                }
                else {
                    var title = sm.portal.utility.getResourceValue('TermsConditions');
                    var body = section.SectionModel().TermsMessage();
                    var ok = sm.portal.utility.getResourceValue('OK');

                    sm.portal.ui.lightBox(title,
                        body,
                        ' smallDialog',
                        null,
                        null,
                        '<button id="confirmAcceptTerms" class="confirmBtn" data-close-lightbox>' + ok + '</button>');
                    return true;
                }
            }

            return true;
        };

        // Not sure if my way of doing this is appropriate, but here they are (please refactor if needed!)
        this.SetFocus = function () {
            var res = sm.portal.vm.custom.callCustomization('CustomSetFocus', self);
            if(!sm.portal.utility.isNullOrEmpty(res)){
                return;
            }
            if (self.CurrentSectionName() == 'Account') {
                return;
            }

            var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);

            if (iOS == false) {
                $('.templateContainer').find('.displayHeader').first().each(function () {
                    var that = $(this);
                    var isButton = (that.find('button').length > 0);
                    if (isButton) {
                        that.find('button').focus();
                    }
                });
                // This script is pretty basic, but it works for the current scenario - could be better.
                $('.templateContainer form').find('.field').first().each(function () {
                    var that = $(this);
                    var isSelect = (that.find('select').length > 0);
                    var isComboBox = (that.find('.comboSearch').length > 0);

                    if (isSelect) {
                        that.find('select').focus();
                    }

                    else if (isComboBox) {
                        if (that.next('.field').find('select').length > 0) {
                            that.next('.field').find('select').focus();
                        }
                        else {
                            that.next('.field').find('input').not(':hidden').focus();
                        }
                    }
                    else {
                        that.find('input').not(':hidden').focus();
                    }
                });
            }
        };

        this.CanCrateUser = ko.computed(function () {
            if (this.IsCreateUserProcessRunning() || !this.Sections || this.Sections().length === 0) {
                return false;
            }
            
            var sectionsArray = this.Sections();
            var neededSectionArray = ['Account', 'BasicPerson'];
            sm.portal.vm.custom.callCustomization('UpdateSectionArray', neededSectionArray);
            
            for (var i = 0; i < sectionsArray.length; i++) {
                if (neededSectionArray.indexOf(sectionsArray[i].SectionName()) > -1) {
                    if (!sectionsArray[i].SectionModel().IsVMValid()) {
                        return false;
                    }

                    if (sectionsArray[i].SectionName() === 'Account' && sectionsArray[i].SectionModel().IsLoggedIn()) {
                        return false;
                    }
                }
            }

            return true;
        }, this);

        // Navigation Controls
        this.NextButtonEnabled = ko.computed(function () {
            // Find the Current Position
            var isAvailable = true;
            var currentIndex = 999;
            var nextIndex = -1;
            var atLastSection = false;

            for (var i = 0; i < this.Sections().length; i++) {
                if (this.Sections()[i].SectionName() == this.CurrentSectionName()) {
                    currentIndex = i;
                }
                else if (i > currentIndex && this.Sections()[i].Applied()) {
                    nextIndex = i;
                }

                // Break if got both
                if (currentIndex < 999 && nextIndex > -1) {
                    break;
                }
            }

            if (smapi.constant.applicationDebugFlag) {
                console.log('[Next-To-Last] Completed: ' + this.CompletedSections().length);
                console.log('[Next-To-Last] Incompleted: ' + this.IncompleteSections().length);
                console.log('[Next-To-Last] Applied: ' + this.AppliedSections().length);
                console.log('[Next-To-Last] Unapplied: ' + this.UnappliedSections().length);
            }

            if (nextIndex == this.Sections().length - 1) {

                // We're on the next-to-last section before the summary,
                // check for Completion

                isAvailable = true; //  this.SummaryAvailable();

            } else if (nextIndex >= this.Sections().length) {
                isAvailable = false;
            }
            var customData = {
                self: self,
                currentIndex: currentIndex,
                isAvailable: isAvailable
            }
            
            if (currentIndex == 0) {
                // We're on the very first section - depending on the security requirements, we may
                // need to verify passwords match before allowing the applicant to continue.
                isAvailable = (self.Sections()[0].AllowNext() || self.Sections()[0].SectionModel().IsLoggedIn());
            }

            var available = sm.portal.vm.custom.callCustomization('CustomizeNextButtonEnabled', customData);  

            if(!sm.portal.utility.isNullOrEmpty(available)){
                if(available!=999){
                    isAvailable = available;
                }
            }

            if (smapi.constant.applicationDebugFlag) { console.log('[NextButtonEnabled] returning ' + isAvailable); }
            return isAvailable;

        }, this);
        this.PreviousButtonEnabled = ko.computed(function () {

            // Find the Current Position
            var isAvailable = true;
            var currentIndex = 999;
            var previousIndex = -1;

            for (var i = this.Sections().length - 1; i > -1; i--) {
                if (this.Sections()[i].SectionName() == this.CurrentSectionName()) {
                    currentIndex = i;
                    if (smapi.constant.applicationDebugFlag) { console.log('[PreviousButtonEnabled] Got Current Index: ' + currentIndex); }
                }
                else if (currentIndex < 999 && this.Sections()[i].Applied()) {
                    previousIndex = i;
                    if (smapi.constant.applicationDebugFlag) { console.log('[PreviousButtonEnabled] Got Previous Index: ' + previousIndex); }
                }

                // Break if got both
                if (currentIndex < 999 && previousIndex > -1) {
                    break;
                }
            }

            if (previousIndex < 0) {
                isAvailable = false;
            }

            if (smapi.constant.applicationDebugFlag) { console.log('[PreviousButtonEnabled] returning ' + isAvailable); }
            return isAvailable;

        }, this);

        // Navigation Handlers
        this.MoveToNextSection = function () {
            var isLoggedIn = this.Sections()[0].SectionModel().IsLoggedIn();

            if (smapi.constant.applicationDebugFlag) { console.log('[MoveToNextSection] Click Fired'); }

            var accountViewModel = viewModel.GetSectionModel('Account');
            if (accountViewModel != null) {
                var newPassword = jQuery("#NewAccountPassword").val();
                var regularExpressionString = accountViewModel.PasswordRegex();
                var regularExpression = new RegExp(regularExpressionString);
                var minNumberofChars = accountViewModel.PasswordMinLength();;
                if (newPassword != undefined && !isLoggedIn) {
                    if (newPassword.length < minNumberofChars) {
                        $.unblockUI();
                        return;
                    }
                    if (!regularExpression.test(newPassword)) {
                        $.unblockUI();
                        return;
                    }
                }
            }

            if(sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization("CanAdvanceAfterTermsHide")) && !this.CanAdvanceAfterTerms(this.CurrentSection())){
                return;
            }

            // Handle the move to the next applied section
            var nextSectionObj = null;
            var currentIndex = 999;
            var nextIndex = -1;

            for (var i = 0; i < this.Sections().length; i++) {
                if (this.Sections()[i].SectionName() == this.CurrentSectionName()) {
                    currentIndex = i;
                }
                else if (i > currentIndex && this.Sections()[i].Applied()) {
                    nextSectionObj = this.Sections()[i];
                    nextIndex = i;
                }

                // Break if got both
                if (currentIndex < 999 && nextIndex > -1) {
                    break;
                }
            }

            if (nextSectionObj != null) {
                var customData = {
                    nextSectionObj :  nextSectionObj,
                    self : self
                }
                sm.portal.vm.custom.callCustomization('CustomMovetoNextSection', customData);
                if (nextSectionObj.SectionName() == 'Summary') {
                    if (this.SubmitAvailable()) {
                        nextSectionObj.Active(true);
                        this.ActiveSectionChanged(nextSectionObj);
                    } else {
                        alert(sm.portal.utility.getResourceValue('NotAllStepsComplete'));
                        // Alert the user there are uncompleted steps
                    }
                } else {
                    nextSectionObj.Active(true);
                    this.ActiveSectionChanged(nextSectionObj);
                    if(nextSectionObj.SectionName() == 'HighSchool' && sm.portal.utility.isAPASFeatureEnabled()){
                        nextSectionObj.SectionModel().Completed(true);
                    }
                }
            }

            if (typeof sm.portal.vm.ukapplication !== 'undefined' && ukFeatureEnabled) {
                sm.portal.vm.ukapplication.MoveToNextSection(this, nextSectionObj);
            } else if (typeof sm.portal.vm.euapplication !== 'undefined' && euFeatureEnabled) {
                sm.portal.vm.euapplication.MoveToNextSection(this, nextSectionObj);
            } else if (typeof sm.portal.vm.apasapplication !== 'undefined' && apasFeatureEnabled) {
                sm.portal.vm.apasapplication.MoveToNextSection(this, nextSectionObj);
            }

            if (typeof sm.portal.vm.conservatoireapplication !== 'undefined' && conservatoireFeatureEnabled) {
                sm.portal.vm.conservatoireapplication.MoveToNextSection(this, nextSectionObj);
            }

        };
        this.MoveToPreviousSection = function () {
            if (smapi.constant.applicationDebugFlag) { console.log('[MoveToPreviousSection] Click Fired'); }

            if(sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization("CanAdvanceAfterTermsHide")) && !this.CanAdvanceAfterTerms(this.CurrentSection())){
                return;
            }

            var prevSectionObj = null;
            var currentIndex = 999;
            var prevIndex = -1;

            for (var i = this.Sections().length - 1; i > -1; i--) {
                if (this.Sections()[i].SectionName() == this.CurrentSectionName()) {
                    currentIndex = i;
                }
                else if (currentIndex < 999 && this.Sections()[i].Applied()) {
                    prevSectionObj = this.Sections()[i];
                    prevIndex = i;
                }

                // Break if got both
                if (currentIndex < 999 && prevIndex > -1) {
                    break;
                }
            }

            if (prevSectionObj != null) {
                prevSectionObj.Active(true);
                this.ActiveSectionChanged(prevSectionObj);
                if(prevSectionObj.SectionName() == 'HighSchool' && sm.portal.utility.isAPASFeatureEnabled()){
                    prevSectionObj.SectionModel().Completed(true);
                }
            }
        };
        this.MoveToSummary = function () {
        
            if(sm.portal.utility.isNullOrEmpty(sm.portal.vm.custom.callCustomization("CanAdvanceAfterTermsHide")) && !this.CanAdvanceAfterTerms(this.CurrentSection())){
                return;
            }

            this.ActiveSectionChanged(this.SummarySection());
        };
        this.NextSectionName = function () {
            // Handle the move to the next applied section
            var nextSectionObj = null;
            var currentIndex = 999;
            var nextIndex = -1;

            for (var i = 0; i < this.Sections().length; i++) {
                if (this.Sections()[i].SectionName() == this.CurrentSectionName()) {
                    currentIndex = i;
                }
                else if (i > currentIndex && this.Sections()[i].Applied()) {
                    nextSectionObj = this.Sections()[i];
                    nextIndex = i;
                }

                // Break if got both
                if (currentIndex < 999 && nextIndex > -1) {
                    break;
                }
            }

            if (nextSectionObj != null) {
                return nextSectionObj.SectionName();
            }
            return "";
        };
        this.PrevSectionName = function () {
            var prevSectionObj = null;
            var currentIndex = 999;
            var prevIndex = -1;

            for (var i = this.Sections().length - 1; i > -1; i--) {
                if (this.Sections()[i].SectionName() == this.CurrentSectionName()) {
                    currentIndex = i;
                }
                else if (currentIndex < 999 && this.Sections()[i].Applied()) {
                    prevSectionObj = this.Sections()[i];
                    prevIndex = i;
                }

                // Break if got both
                if (currentIndex < 999 && prevIndex > -1) {
                    break;
                }
            }

            if (prevSectionObj != null) {
                return prevSectionObj.SectionName();
            }
            return "";
        };

        // Security Handlers
        this.IsUserLoggedIn = function () {

            if (!sm.portal.utility.isNullOrEmpty(_currentPersonId) && _currentPersonId > 0) {
                viewModel.IsLoggedIn(true);
                viewModel.ShowLogin(false);

            } else {
                viewModel.IsLoggedIn(false);
                viewModel.ShowLogin(true);
            }

            if (callback != undefined && callback != null) {
                callback();
            }
        };

        //Login Handlers
        this.PartialApps = ko.observableArray();
        this.HandlePartialApplications = function (personGID) {
            if (personGID != null && this.ShowPartialPopup()) {
                var accountViewModel = viewModel.GetSectionModel('Account');
                if (!sm.portal.utility.isNullOrEmpty(personGID) && accountViewModel.IsLoggedIn()) {
                    this.GetPartialData(personGID);
                }
            }
        };

        // this gets the partial applications for a person and displays this as a popup
        this.GetPartialData = function (gid) {
            var url = _baseApiUri + 'api/studentportal/getapplicationsinprocessfromperson';
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    if (data.Status == 'success' && data.Payload != null && data.Payload.PartialApplications != null) {
                        viewModel.PartialApps(data.Payload.PartialApplications);
                        // Now run the functions for Partial app popup
                        var title = $('#partialApplicationContainer').attr('data-dialog-title');
                        sm.portal.ui.lightBox(title, $('#partialApplicationContainer'), 'smallDialog', null, null, null, function () {
                            $('.smModal .smModalClose').on('click', function () {
                                viewModel.ShowPartialData(false);
                                viewModel.ShowPartialPopup(false);
                            });
                        });

                        viewModel.ShowPartialData(true);
                        viewModel.ShowPartialPopup(false);
                    }
                    else {
                        viewModel.ShowPartialData(false);
                        viewModel.ShowPartialPopup(false); //Default to Shown so that it never shows again
                    }
                    $.unblockUI();
                },
                error: function (jqXHR, exception) {

                    console.log('** Error on partial retrevial: Person GID =' + gid);
                    $.unblockUI();
                }
            });
        };
        this.OpenApplication = function (partial, event) {
            if (partial != null && partial.GID != null) {
                if (event.type === "click" || (event.type === "keypress" && (event.which == 13 || event.which == 32))) {
                    var joinOperator = window.location.href.indexOf("?") == -1 ? "?" : "&";
                    window.location.href = window.location.href + joinOperator + "attemptGID=" + partial.GID;
                }
            }
        };

        // Error Handling
        this.ErrorHeader = ko.observable();
        this.ErrorMessages = ko.observableArray();
        this.IsError = ko.observable();

        // Extraction Method
        this.ExtractATO = function () {
            
            // Get the full Section Data
            var accountSecData = this.GetSectionModel('Account');
            var personSecData = this.GetSectionModel('BasicPerson');
            var contactSecData = this.GetSectionModel('BasicContact');
            var academicSecData = this.GetSectionModel('Academic');
            var demographicSecData = this.GetSectionModel('Demographic');
            var employmentSecData = this.GetSectionModel('Employment');
            var collegeSecData = this.GetSectionModel('College');
            var highSchoolSecData = this.GetSectionModel('HighSchool');
            var placementTestSecData = this.GetSectionModel('TestScore');

            var beforeTermSecData = this.GetSectionModel('BeforeTerms');
            var afterTermSecData = this.GetSectionModel('AfterTerms');
            var requiredModels = sm.portal.vm.custom.callCustomization('LoadMissingModels',self);
            // Consolidate IDs
            var personID = null;
            var personGID = null;
            if (!sm.portal.utility.isNullOrEmpty(accountSecData.PersonID()) && accountSecData.PersonID() > 0) {
                personID = accountSecData.PersonID();
                personGID = accountSecData.PersonGID();
            }
            else if (!sm.portal.utility.isNullOrEmpty(personSecData.ID()) && personSecData.ID() > 0) {
                personID = personSecData.ID();
                personGID = personSecData.GID();
            }
            else if (!sm.portal.utility.isNullOrEmpty(this.PersonID()) && this.PersonID() > 0) {
                personID = this.PersonID();
                personGID = this.PersonGID();
            }
            // Construct the College ATO Object
            var previousCollegeData = null;
            if (collegeSecData) {
                previousCollegeData = collegeSecData.ExtractATO();
            }
            // Construct the list of Placement Test objects.
            var testScoreData = null;
            if (placementTestSecData) {
                testScoreData = placementTestSecData.ExtractATO();
            }
            // Construct the HS ATO Object
            var previousHighSchoolData = highSchoolSecData.ExtractATO();
            var highSchoolInformationModel = Array();
            var highSchoolAddressInformation = Array();
            for (var i = 0; i < previousHighSchoolData.length; i++) {
                highSchoolInformationModel.push(previousHighSchoolData[i].HighSchoolInformationModel);
                highSchoolAddressInformation.push(previousHighSchoolData[i].HighSchoolAddressInformation);
            }
            // Person object
            var stdPerson = personSecData.ExtractATO(); 
            // Contact Information
            var contactDetails = contactSecData.ExtractATO();
        
            if (!sm.portal.utility.isNullOrEmpty(contactDetails.PhoneNumber.Number())) {
                stdPerson.Person.PhoneNumbers.push(contactDetails.PhoneNumber);
            }


            stdPerson.Person.Addresses.push(contactDetails.MailingAddress);


            var customData = {
                personSecData : personSecData,
                stdPerson : stdPerson,
                contactSecData : contactSecData,
                contactDetails : contactDetails
            }

            var result = sm.portal.vm.custom.callCustomization('SetElectronicAddress', customData);            

            if(sm.portal.utility.isNullOrEmpty(result)){
                if (!sm.portal.utility.isNullOrEmpty(stdPerson.Email.Value())) {
                    stdPerson.Person.ElectronicAddresses.push(stdPerson.Email);
                }
               
                stdPerson.Person.DoNotContact(contactDetails.DoNotContact);
    
            }

            sm.portal.vm.custom.callCustomization('SetPersonDetails', customData);

            // Construct the Demographic ATO object
            var demographicData = demographicSecData.ExtractATO();
            
            var cusData = {
                stdPerson: stdPerson,
                demographicSecData: demographicSecData,
                requiredModels: requiredModels,
                employmentSecData: employmentSecData
            }
            var employmentInformation = Array();
            var employerNames = Array();

            var ExtraModels = sm.portal.vm.custom.callCustomization('CustomizeDemographicATOobject', cusData);

            if (sm.portal.utility.isNullOrEmpty(self.SummaryInfoMessageTemplate())) {
                var employment = employmentSecData.ExtractATO();
                stdPerson.Person.Employment.push(employment);
    
                // Construct the Employment ATO object
                for (var i = 0; i < employment.length; i++) {
                    employmentInformation.push(employment[i].EmploymentInformation);
                    employerNames.push(employment[i].EmployerNames);
                }                    
            }

            // New AdmissionsModel - basic information
            var stdAttempt = academicSecData.ExtractATO();

            stdAttempt.Surname(stdPerson.Person.Surname());
            stdAttempt.GivenName(stdPerson.Person.GivenName());
            stdAttempt.MiddleName(stdPerson.Person.MiddleName());
            
            //Before Terms
            var termsData = beforeTermSecData.ExtractATO();
            //After Terms
            termsData = termsData.concat(afterTermSecData.ExtractATO());

            for (var i = 0; i < termsData.length; i++) {
                termsData[i].PersonID(this.PersonID());
                termsData[i].ProcessObjectID(this.ApplicationID());
            }

            termsData = ko.toJS(termsData);

            // ID Consolidation
            stdAttempt.PersonID(personID);
            stdPerson.Person.ID(personID);
            stdPerson.Person.GID(personGID);
            stdAttempt.ID(this.ApplicationID());
            stdAttempt.GID(this.ApplicationGID());
            stdAttempt.AdmissionsStageID(this.AdmissionsStageID());
            stdAttempt.Milestones(this.Milestones());

            var applicationInformationData = sm.portal.vm.custom.callCustomization('ApplicationInformationData', requiredModels);
            
            var data = {
                applicationInformationData: applicationInformationData,
                stdAttempt: stdAttempt,
                contactDetails: contactDetails

            }
            
            var CusRet = sm.portal.vm.custom.callCustomization('CustomizeStdAttempt', data);
            if(CusRet == false){
                return false;
            }
            var genericMap = {};
            genericMap["HighSchool"] = {
                ObjectType: "ProcessStage",
                ObjectTypeName: "TRS.CAMS.Admissions.Entity.Api.HighSchoolInformationATO, TRS.CAMS.Admissions.Entity",
                StageTypeName: "TRS.CAMS.Admissions.Entity.HighSchoolInformationStep, TRS.CAMS.Admissions.Entity",
                StageBusinessMeaningName: "Application.HighSchoolInformation"
            };
            genericMap["PaymentInformation"] = {
                ObjectType: "ProcessStage",
                ObjectTypeName: "TRS.CAMS.Admissions.Entity.Api.AdmissionsPaymentInformationATO, TRS.CAMS.Admissions.Entity",
                StageTypeName: "TRS.CAMS.Admissions.Entity.AdmissionsPaymentInformationStep, TRS.CAMS.Admissions.Entity",
                StageBusinessMeaningName: "Application.Fee"
            };
            genericMap["College"] = {
                ObjectType: "ProcessStage",
                ObjectTypeName: "TRS.CAMS.Admissions.Entity.Api.CollegeInformationATO, TRS.CAMS.Admissions.Entity",
                StageTypeName: "TRS.CAMS.Admissions.Entity.CollegeInformationStep, TRS.CAMS.Admissions.Entity",
                StageBusinessMeaningName: "Application.PreviousCollegeInformation"
            };
            genericMap["ACT"] = {
                ObjectType: "ProcessStage",
                ObjectTypeName: "TRS.CAMS.Admissions.Entity.Api.ACTATO, TRS.CAMS.Admissions.Entity",
                StageTypeName: "TRS.CAMS.Admissions.Entity.ACTStep, TRS.CAMS.Admissions.Entity",
                StageBusinessMeaningName: "Application.ACTScore"
            };
            genericMap["SAT"] = {
                ObjectType: "ProcessStage",
                ObjectTypeName: "TRS.CAMS.Admissions.Entity.Api.SATATO, TRS.CAMS.Admissions.Entity",
                StageTypeName: "TRS.CAMS.Admissions.Entity.SATStep, TRS.CAMS.Admissions.Entity",
                StageBusinessMeaningName: "Application.SATScore"
            };

            genericMap["TOEFL"] = {
                ObjectType: "ProcessStage",
                ObjectTypeName: "TRS.CAMS.Admissions.Entity.Api.TOEFLATO, TRS.CAMS.Admissions.Entity",
                StageTypeName: "TRS.CAMS.Admissions.Entity.TOEFLStep, TRS.CAMS.Admissions.Entity",
                StageBusinessMeaningName: "Application.TOEFL"
            };
            genericMap["Praxis"] = {
                ObjectType: "ProcessStage",
                ObjectTypeName: "TRS.CAMS.Admissions.Entity.Api.PraxisATO, TRS.CAMS.Admissions.Entity",
                StageTypeName: "TRS.CAMS.Admissions.Entity.PraxisStep, TRS.CAMS.Admissions.Entity",
                StageBusinessMeaningName: "Application.PraxisScore"
            };
            genericMap["PraxisII"] = {
                ObjectType: "ProcessStage",
                ObjectTypeName: "TRS.CAMS.Admissions.Entity.Api.PraxisIIATO, TRS.CAMS.Admissions.Entity",
                StageTypeName: "TRS.CAMS.Admissions.Entity.PraxisIIStep, TRS.CAMS.Admissions.Entity",
                StageBusinessMeaningName: "Application.PraxisIIScore"
            };
            genericMap["GRE"] = {
                ObjectType: "ProcessStage",
                ObjectTypeName: "TRS.CAMS.Admissions.Entity.Api.GREGeneralATO, TRS.CAMS.Admissions.Entity",
                StageTypeName: "TRS.CAMS.Admissions.Entity.GREGeneralStep, TRS.CAMS.Admissions.Entity",
                StageBusinessMeaningName: "Application.GREScore"
            };
            genericMap["GMAT"] = {
                ObjectType: "ProcessStage",
                ObjectTypeName: "TRS.CAMS.Admissions.Entity.Api.GMATATO, TRS.CAMS.Admissions.Entity",
                StageTypeName: "TRS.CAMS.Admissions.Entity.GMATStep, TRS.CAMS.Admissions.Entity",
                StageBusinessMeaningName: "Application.GMATScore"
            };
            var updatedCustomGenericMap  = sm.portal.vm.custom.callCustomization('CustomGenericMap');
            if(!sm.portal.utility.isNullOrEmpty(updatedCustomGenericMap )){
                genericMap = updatedCustomGenericMap ;
            }
            var genericData = {};
            genericData["HighSchool"] = previousHighSchoolData;
            genericData["College"] = previousCollegeData;
            if (testScoreData) {
                genericData["ACT"] = testScoreData.ACT;
                genericData["SAT"] = testScoreData.SAT;
                genericData["TOEFL"] = testScoreData.TOEFL;
                genericData["Praxis"] = testScoreData.PRAXIS;
                genericData["PraxisII"] = testScoreData.PRAXISII;
                genericData["GRE"] = testScoreData.GREGeneral;
                genericData["GMAT"] = testScoreData.GMAT;
            }
            var genericDataUpdated = sm.portal.vm.custom.callCustomization('UpdateGenericData', highSchoolInformationModel);
            if(!sm.portal.utility.isNullOrEmpty(genericDataUpdated)){
                genericData = genericDataUpdated;
            }
            // Finally, construct the model to submit to the service.
            var submitModel = {
                GID: this.ApplicationGID(),
                ID: this.ApplicationID(),

                // Account Data
                NewAccountPassword: accountSecData.NewAccountPassword(),
                PersonID: accountSecData.PersonID(),
                PersonGID: accountSecData.PersonGID(),

                PersonalInformation: ko.toJS(stdPerson.Person),
                AdmissionsInformation: ko.toJS(stdAttempt),

                DemographicInformation: ko.toJS(demographicData),

                GenericMap: genericMap,
                GenericData: genericData,

                TermsData: termsData,
                HighSchoolAddressInformation: ko.toJS(highSchoolAddressInformation)
            };
            var DataCustom = {
                ExtraModels: ExtraModels,
                submitModel: submitModel,
                contactSecData: contactSecData
            }
            sm.portal.vm.custom.callCustomization('SubmitModel',DataCustom)

            if (sm.portal.utility.isNullOrEmpty(self.SummaryInfoMessageTemplate())) {
                submitModel.EmploymentInformation = ko.toJS(employmentInformation);
                submitModel.EmployerNames = ko.toJS(employerNames);   
            }


            if (sm.portal.utility.isNullOrEmpty(submitModel.PersonID)) {
                submitModel.PersonID = this.PersonID();
            }
            if (sm.portal.utility.isNullOrEmpty(submitModel.PersonGID)) {
                submitModel.PersonGID = this.PersonGID();
            }
            if(genericDataUpdated){
                return submitModel;
            }
            if (typeof sm.portal.vm.ukapplication !== 'undefined' && ukFeatureEnabled) {
                submitModel = sm.portal.vm.ukapplication.ExtractATO(this, submitModel, stdAttempt, stdPerson.Person);
                sm.portal.vm.custom.callCustomization('SetPersonGenderID', submitModel);
                sm.portal.vm.custom.callCustomization('SetGenderIdentityID', submitModel);
                sm.portal.vm.custom.callCustomization('SetSexualOrientationID', submitModel);
            } else if (typeof sm.portal.vm.euapplication !== 'undefined' && euFeatureEnabled) {
                submitModel = sm.portal.vm.euapplication.ExtractATO(this, submitModel, stdAttempt, stdPerson.Person);
            } else if (typeof sm.portal.vm.apasapplication !== 'undefined' && apasFeatureEnabled) {
                submitModel = sm.portal.vm.apasapplication.ExtractATO(this, submitModel, stdAttempt, stdPerson.Person);
            }

            if (typeof sm.portal.vm.conservatoireapplication !== 'undefined' && conservatoireFeatureEnabled) {
                submitModel = sm.portal.vm.conservatoireapplication.ExtractATO(this, submitModel, stdAttempt, stdPerson.Person);
            }

            return submitModel;
        };

        this.PerformApplicationAutoSave = function () {
            if (this.CanCrateUser()) {

                var userCreatedSuccessCallback = function () {
                    viewModel.ShowUserCreatedNotification(true);
                    viewModel.IsCreateUserProcessRunning(false);
                    setTimeout(function () { viewModel.ShowUserCreatedNotification(false); }, 5000);
                    viewModel.ProcessApplicationInProgress();
                };

                this.IsCreateUserProcessRunning(true);
                this.CallUserCreation(userCreatedSuccessCallback);
            }
            else if (this.GetSectionModel('Account').IsLoggedIn() && this.GetSectionModel('Academic').IsVMValid()) {
                this.ProcessApplicationInProgress();
            }
            else if (this.shouldUpdatePersonalInfo()) {
                this.UpdatePersonInformation();
            }
        };

        this.shouldUpdatePersonalInfo = function () {
            return this.GetSectionModel('Account').IsLoggedIn() &&
                (this.CurrentSection().SectionName() === 'BasicContact' || this.CurrentSection().SectionName() === 'BasicPerson') &&
                this.GetSectionModel('Account').IsVMValid();
        };

        // Submission Method
        this.ProcessApplicationInProgress = function () {
            if (!self.Saving()) {

                // TODO: In Progress Saving of application - so they can come back to it.
                var submitData = self.ExtractATO();

                var availableForIncremental = true;
                if (sm.portal.utility.isNullOrEmpty(submitData.PersonalInformation)) { return; }
                if (sm.portal.utility.isNullOrEmpty(submitData.PersonalInformation.GivenName)) { availableForIncremental = false; }
                if (sm.portal.utility.isNullOrEmpty(submitData.PersonalInformation.Surname)) { availableForIncremental = false; }
                if (submitData.PersonalInformation.ElectronicAddresses.length == 0) { availableForIncremental = false; }

                // TODO: Scott's Suggestion, change the Application Type or Stage or ProcessStage to Inquiry or something not as restrictive to incremental save.

                if (availableForIncremental) {      // TODO: Change to use variable to implement.

                    self.ShowPartialPopup(false); // DO NOT show the partial popup, if this isn't set

                    self.Saving(true);

                    var url = _baseApiUri + 'api/studentportal/PersistPartialApplication?id=';
                    if (!sm.portal.utility.isNullOrEmpty(self.ApplicationID())) {
                        url += self.ApplicationID();
                    }
                    $.ajax({
                        url: url,
                        type: 'POST',
                        dataType: 'json',
                        data: JSON.stringify(submitData),
                        contentType: 'application/json; charset=utf-8',
                        headers: {
                            "x-api-version": '1' //,
                        },
                        processData: false,
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        },
                        success: function (data, textStatus, jqXHR) {
                            var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                            if (data.Status == 'saved') {

                                viewModel.ApplicationGID(container.Payload.ApplicationGID);
                                viewModel.ApplicationID(container.Payload.ApplicationID);
                                viewModel.PersonGID(container.Payload.PersonGID);
                                viewModel.PersonID(container.Payload.PersonID);
                                viewModel.AdmissionsStageID(container.Payload.AdmissionsStageID);
                                viewModel.Milestones(container.Payload.Milestones);

                                // Dynamic Section
                                if (container.Payload.TestSections && viewModel.GetSectionModel('TestScore')) {
                                    var testScoreViewModel = viewModel.GetSectionModel('TestScore');
                                    testScoreViewModel.LoadModel(container);
                                }

                                var hsViewModel = viewModel.GetSectionModel('HighSchool');
                                hsViewModel.LoadModel(container);

                                var collegeViewModel = viewModel.GetSectionModel('College');
                                if (!sm.portal.utility.isNullOrEmpty(collegeViewModel)) {
                                    collegeViewModel.LoadModel(container);
                                }

                                viewModel.Saved(true);
                                viewModel.HasBeenSaved(true);
                                var customData  = {
                                    viewModel: viewModel,
                                    container: container 
                                }
                                sm.portal.vm.custom.callCustomization('UpdatePersistQualification', customData);

                                setTimeout(function () {
                                    viewModel.Saved(false);
                                    viewModel.Saving(false);
                                    // with section order change, dependent section may come just before summary section
                                    // so, once user navigates to summary section, dynamic sections should load
                                    viewModel.CheckSectionsForInclusion();
                                    sm.portal.ui.detailedList();

                                }, 3000);

                            } else if (data.Status == 'notyet' || data.Status == 'error') {
                                // Do Nothing, not ready for an incremental save...
                                viewModel.Saving(false);
                                viewModel.IsCreateUserProcessRunning(false);
                                if (data.Status == 'notyet' && data.ValidationTitle && !data.ValidationTitle.includes('Academic Level must have a value')) {
                                    viewModel.ThrowErrorWithRelevantMessage(jqXHR, 'save');
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            if (jqXHR && jqXHR.responseJSON) {
                                viewModel.HandleError(exception + jqXHR.responseJSON.Message);
                            } else {
                                viewModel.HandleError('Error');
                            }
                            viewModel.Saving(false);
                            viewModel.ThrowErrorWithRelevantMessage(jqXHR, 'save');
                        }
                    });
                }
            }
        };

        this.UsercreationFail = function () {
            var PersonRecordCreationErrorOkButton = '<div><button class="userCreationFail_Ok_button" >' + sm.portal.utility.getResourceValue('OK') + '</button></div>';
            var PersonRecordCreationErrorMsg = '<p>' + sm.portal.utility.getResourceValue('ErrorMessageNotLoggedIn') + '</p>';
            
            sm.portal.ui.lightBox(
                sm.portal.utility.getResourceValue('AccountCreationErrorMsg'),
                PersonRecordCreationErrorMsg,
                'userCreationFailPopUp',
                function () {
                    jQuery('.userCreationFail_Ok_button').on('click',
                    function () {
                        location.reload();
                    }
                    );
                },
                null,
                PersonRecordCreationErrorOkButton,
                null,
                null,
                null,
                'UserCreationFail',
                null
            );
        }

        this.CallUserCreation = function (UserCreatedCallback) {
            if (!self.Saving()) {
                   
                var submitData = self.ExtractATO();
                
                self.Saving(true);
                
                var url = _baseApiUri + 'api/studentportal/CreatePortalUserFromPartialApplication?id=';
                if (!sm.portal.utility.isNullOrEmpty(self.ApplicationID())) {
                    url += self.ApplicationID();
                }

                $.ajax({
                    url: url,
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(submitData),
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                        if (data.Status == 'saved') {
                            if (container.Payload.CreatePortalUserStatus == "success") {

                                var basicPersonViewModel = self.GetSectionModel('BasicPerson');
                                var firstName = basicPersonViewModel != null ? basicPersonViewModel.FirstName() : "";

                                basicPersonViewModel.InitializeOnUserCreated(container.Payload);

                                var accountViewModel = viewModel.GetSectionModel('Account');
                                if (accountViewModel != null && !accountViewModel.IsLoggedIn()) {
                                    accountViewModel.InitializeAndLoginUser(container.Payload, UserCreatedCallback, firstName, true, false);
                                }
                            }
                            viewModel.Saving(false);
                            viewModel.AppendNotExistingWarnings(container.Payload.WarningMessages);

                        } else if (container && container.Payload && container.Payload.CreatePortalUserStatus == 'error') {
                            self.UsercreationFail();
                            viewModel.Saving(false);
                        }
                        else if (data.Status == 'notyet' || data.Status == 'error') {
                            // Do Nothing, not ready for an incremental save...
                            viewModel.Saving(false);
                            viewModel.ThrowErrorWithRelevantMessage(jqXHR, 'save');
                        }
                    },
                    error: function (jqXHR, exception) {
                        viewModel.HandleError(exception);
                        viewModel.Saving(false);
                        viewModel.ThrowErrorWithRelevantMessage(jqXHR, 'save');
                    }
                });

            }
        };

        this.UpdatePersonInformation = function () {
            if (!self.Saving()) {

                var submitData = self.ExtractATO();

                self.Saving(true);
                var url = _baseApiUri + 'api/studentportal/UpdateUserInformation';

                var onSuccess = function (data, textStatus, jqXHR) {
                    viewModel.Saved(true);

                    setTimeout(function () {
                        viewModel.Saved(false);
                        viewModel.Saving(false);
                    }, 3000);
                };

                var onError = function (jqXHR, exception) {
                    viewModel.HandleError(exception);
                    viewModel.ThrowErrorWithRelevantMessage(jqXHR, 'save');
                    viewModel.Saving(false);
                };

                sm.portal.utility.AjaxPost(
                    url,
                    JSON.stringify(submitData),
                    onSuccess,
                    onError
                );
            }
        };

        this.UpdatePersonInformation = function () {
            if (!self.Saving()) {

                var submitData = self.ExtractATO();

                self.Saving(true);
                var url = _baseApiUri + 'api/studentportal/UpdateUserInformation';

                var onSuccess = function (data, textStatus, jqXHR) {
                    viewModel.Saved(true);

                    var accountViewModel = self.GetSectionModel('Account');
                    var basicPersonViewModel = self.GetSectionModel('BasicPerson');
                    if (accountViewModel !== null && basicPersonViewModel !== null) {
                        accountViewModel.PersonFirstName(basicPersonViewModel.FirstName());
                    }

                    setTimeout(function () {
                        viewModel.Saved(false);
                        viewModel.Saving(false);
                    }, 3000);
                };

                var onError = function (jqXHR, exception) {
                    viewModel.HandleError(exception);
                    viewModel.ThrowErrorWithRelevantMessage(jqXHR, 'save');
                    viewModel.Saving(false);
                };

                sm.portal.utility.AjaxPost(
                    url,
                    JSON.stringify(submitData),
                    onSuccess,
                    onError
                );
            }
        };

        this.CheckSectionsForInclusion = function () {
            // Attempt to check Inclusion for other sections - not sure if this is the best place for it, but it gets called a lot..
            for (var i = 0; i < viewModel.Sections().length; i++) {
                var nextSection = viewModel.Sections()[i];
                if (!sm.portal.utility.isNullOrEmpty(nextSection.SectionModel()) && !nextSection.SectionModel().DataLoading() && self.CurrentSectionName() != nextSection.SectionName()) {
                    if (smapi.constant.applicationDebugFlag) { console.log('[SectionModel.Activate] Inclusion Checking ' + nextSection.SectionName()); }
                    try {
                        nextSection.SectionModel().CheckInclusion(this.ApplicationMID(), this.PersonMID());
                    } catch (e) {
                        if (smapi.constant.applicationDebugFlag) { console.log('[SectionModel.CheckInclusion] Method not found ' + nextSection.SectionName()); }
                    }
                }
            }
        };

        this.SubmitApplication = function () {
            $.blockUI();
            var submitData = self.ExtractATO();

            // Submit the object to the service
            var url = _baseApiUri + 'api/studentportal/SubmitApplication?id=';
            if (!sm.portal.utility.isNullOrEmpty(self.ApplicationID())) {
                url += self.ApplicationID();
            }

            var model = self.GetSectionModel(self.CurrentSectionName());
            model.BlockContainer();

            self.IsError(false);
            self.ErrorHeader("");

            $('html,body').animate({
                scrollTop: $('.smContentArea').offset().top
            }, 500);

            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: JSON.stringify(submitData),
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'submitted') {
                        if (data.Payload.IsPaymentProviderEnabled) {
                            GetPaymentProviderName();
                        }
                        viewModel.Result_PersonGivenName('');
                        if (container.Payload.PersonGivenName.length > 0) {
                          viewModel.Result_PersonGivenName(container.Payload.PersonGivenName);
                        }
                        viewModel.BaseU4SMUrl(container.Payload.BaseServiceUrl);
                        viewModel.Submitted(true);
                        viewModel.PaymentDetails(data.Payload.PaymentDetails)
                        viewModel.AppendNotExistingWarnings(container.Payload.WarningMessages);
                        if (container.Payload.BiilingDomicileSettings !== undefined) {
                            viewModel.IsBillingDomicileMappingCorrect(container.Payload.BiilingDomicileSettings.IsBillingDomicileMappingCorrect);
                            viewModel.BillingDomicileMessage(container.Payload.BiilingDomicileSettings.BillingDomicileMessage);
                            viewModel.IsBillingDomicilePaymentProviderEnabled(container.Payload.BiilingDomicileSettings.IsBillingDomicilePaymentProviderEnabled);
                            viewModel.BillingDomicilePaymentProviders(container.Payload.BiilingDomicileSettings.PaymentProviders);
                        }
                        if (!self.IsBillingDomicilePaymentProviderEnabled()) {
                            AttachMakePayment(data.Payload.IsPaymentProviderEnabled, data.Payload.PaymentDetails);
                        }
                        if (container.Payload.PostSubmissionFlowSettings == "Custom" && container.Payload.ApplicationFee.length) {
                            viewModel.SubmittedWithPostSubmissionFlowCustom(true);
                            viewModel.ApplicationFee(container.Payload.ApplicationFee);
                        }
                        var customData = {
                            viewModel: viewModel,
                            container: container
                        }
                        sm.portal.vm.custom.callCustomization('CallSetUpPebblePad', customData);
                    } else if (data.Status == 'validationerror') {

                        viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                        viewModel.ThrowErrorWithRelevantMessage(jqXHR, 'save');
                        // TODO: Identify and highlight the associated fields (if possible)

                    } else if (data.Status == 'error') {

                        viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                        viewModel.ThrowErrorWithRelevantMessage(jqXHR, 'save');
                    }
                    $.unblockUI();
                    model.UnBlockContainer();
                },
                error: function (jqXHR, exception) {
                    viewModel.HandleError(exception);
                    model.UnBlockContainer();
                    $.blockUI();
                    viewModel.ThrowErrorWithRelevantMessage(jqXHR, 'save');
                }
            });
        };

        self.PaymentProviderSelectionPopup = function () {
            jQuery.blockUI();
            function GenerateHTMLForPaymentMethods() {
                var result='';
                if (self.BillingDomicilePaymentProviders().length > 0) {
                    for (var i = 0; i < self.BillingDomicilePaymentProviders().length; i++) {
                        result = result +
                            '<div class="fieldGroup radioLabel">' +
                            '<div class="field">' +
                            '<div style="float:left">' +
                            '<label for=' + self.BillingDomicilePaymentProviders()[i].ID + '>' +
                            '<input type="radio" name="radioPayment" id= ' + self.BillingDomicilePaymentProviders()[i].ID + ' value= ' + self.BillingDomicilePaymentProviders()[i].Name + ' />' +
                            '<span>' + self.BillingDomicilePaymentProviders()[i].Name + '</span>' +
                            '</label>' +
                            '</div>' +
                            '</div>' +
                            '</div>'
                    }
                }
                return result
            }
            var bodyContent = GenerateHTMLForPaymentMethods();
            var buttonContent = '<button class="cancelBtn" onclick="sm.portal.vm.closeModal(\'Cancel\');" >' + sm.portal.utility.getResourceValue('Cancel') +
                '</button>' +
                '<button id="MakePaymentbtn" class="confirmBtn f-right" disabled >' + sm.portal.utility.getResourceValue('MakePayment') + '</button>';
            sm.portal.ui.lightBox(sm.portal.utility.getResourceValue('MakePayment'), bodyContent, 'smallDialog', null, null, buttonContent);
            jQuery.unblockUI();

            jQuery('input[name="radioPayment"]').on('change', function () {
                if (jQuery(this).is(':checked')) {
                    jQuery('#MakePaymentbtn').removeAttr('disabled');
                }
                else {
                    jQuery('#MakePaymentbtn').attr('disabled', '');
                }
            })

            jQuery('#MakePaymentbtn').click(function () {
                var selectedPaymentProvider = jQuery('input[name="radioPayment"]:checked');
                var selectedPaymentProviderId = selectedPaymentProvider.attr('id');
                var selectedPaymentProviderName = selectedPaymentProvider.attr('value');
                self.PaymentProviderName(selectedPaymentProviderName);
                viewModel.PaymentProviderID(selectedPaymentProviderId);
                sm.portal.ui.removeLightbox();
                if (self.PaymentProviderName() === "FlywireV2") {
                    jQuery("#flywireVisibleButton").click();
                } else if (selectedPaymentProviderName === "Flywire") {
                    jQuery('#flywireButton').click();
                } else {
                    self.worldpaybtnMakePayment();
                }
            });

        };

        this.worldpaybtnMakePayment = function () {
            MakePayment(viewModel.PaymentDetails());
        };

        this.ReviewApplicantChecklist = function () {
            $.blockUI();

            $.ajax({
                type: 'GET',
                url: _baseApiUri + 'api/ApplicationSetting/GetPortalUserApplicantChecklistURL',
                contentType: false,
                global: true,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    $.unblockUI();
                    window.location.replace(data);
                },
                error: function (jqXHR, exception) {
                    $.unblockUI();
                    viewModel.HandleError(exception);
                }
            });
        };

        return self;
    };

    this.MakePayment = function (paymentDetails) {
        $.blockUI();
        sm.portal.utility.get('api/Reenrollment/PaymentConfirmationRedirectURL', function (output) {
            var url = _baseApiUri + 'api/portalstudentledger/CreatePaymentForm/';
            paymentDetails["PaymentLocation"] = output.Payload.RedirectPaymentPageURL;
            if (viewModel.IsBillingDomicilePaymentProviderEnabled()) {
                paymentDetails["PaymentProviderId"] = viewModel.PaymentProviderID();
            }
            
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: JSON.stringify(paymentDetails),
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1'
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    $(data).appendTo('body').submit();
                },
                error: function (xhr, ajaxOptions, exception) {
                    self.HandleError(exception);
                    $.unblockUI();
                }
            });
        });
    };

    this.AttachMakePayment = function (isPaymentProviderEnabled, paymentDetails) {
        if (isPaymentProviderEnabled) {
            viewModel.IsPaymentProviderEnabled(true);
            $('button[data-payment-button]').on('click', function () {
                MakePayment(paymentDetails);
            });
        }
    };

    this.GetPaymentProviderName = function () {
        if (viewModel.IsPaymentProviderEnabled) {
            var url = _baseApiUri + sm.portal.utility.formatString('api/portalstudentledger/GetPaymentProviderName');
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1'
                },
                processData: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    viewModel.PaymentProviderName(data);
                },
                error: function (exception) {
                    viewModel.HandleError(exception);
                }
            });
        }
    };

    $.extend(true, sm.portal.vm, {
        ApplicationViewModel: ApplicationViewModel,
    })

})(jQuery);